import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { EventModel } from 'src/app/_shared/event/event.model';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })

export class EventListService {

    constructor(private http: HttpClient) {}

    token: string = localStorage.getItem('token');

    readonly BaseUrl = environment.baseUrl;
    headers = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Token': this.token
        })
    };

    populateEventList(date: string): Observable<any> {
        return this.http.get<any>(this.BaseUrl + `/Calendar/GetDate/${date}`, this.headers);
    }

    editEvent(eventId: string): Observable<any> {
        return this.http.get<any>(this.BaseUrl + `/Event/GetExistingEvent/${eventId}`, this.headers);
    }

    copyEvent(event: any): Observable<any> {
        const eventModel = this.mapEventModel(event);
        return this.http.post<any>(this.BaseUrl + `/Event/CopyEvent`, JSON.stringify(eventModel), this.headers);
    }

    deleteEvent(event: any): Observable<any> {
        return this.http.delete<any>(this.BaseUrl + `/Event/DeleteEvent/${event.Id}`, this.headers);
    }

    mapEventModel(event: any): EventModel
    {
        const eventModel: EventModel = {
            StartDate: event.StartDate,
            Project: event.Project,
            User: event.User,
            MinutesSpent: event.MinutesSpent,
            MinutesEstimate: event.MinutesEstimate,
            UserComment: event.UserComment,
            Date: event.Date,
            IsDeleted: event.IsDeleted,
            IsLocked: event.IsLocked,
            SpentHours: event.SpentHours,
            EstimateHours: event.EstimateHours,
            SpentMinutes: event.SpentMinutes,
            FormattedTimeSpent: event.FormattedTimeSpent
        };

        return eventModel;
    }

}
